/* istanbul ignore file */
import React from 'react';
import { initialState } from '../../states/state';
export var ChatContext = React.createContext(initialState);
//# sourceMappingURL=ChatContext.js.map